import { BaseSearchParametersModel } from "../../../models/base-search-parameters.model";

export class ContentSearchParametersModel extends BaseSearchParametersModel {
    public searchContext: string;
}
